import { memo } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { routes } from '@/router/index';
import { useBearer } from '@/store/bearer';

const ProtectedAdminRoute = memo(({ className }: { className?: string }) => {
  const { bearer } = useBearer();
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (isAdminRoute && !bearer) {
    return (
      <>
        <Outlet />
        <Navigate to={routes.admin.login} replace />
      </>
    );
  }

  return <Outlet />;
});

ProtectedAdminRoute.displayName = 'ProtectedAdminRoute';
export default ProtectedAdminRoute;
